import { useQuery } from '@tanstack/react-query';
import {
  usersQueryOptions,
  userQueryOptions,
  planetUsersQueryOptions,
} from '../server/queries/users';

/**
 * Fetches the full list of users.
 */
export function useUsers() {
  return useQuery(usersQueryOptions());
}

/**
 * Fetches a single user by ID.
 */
export function useUser(id: string) {
  return useQuery(userQueryOptions(id));
}

/**
 * Fetches all users belonging to a specific planet.
 */
export function usePlanetUsers(planetId: string) {
  return useQuery(planetUsersQueryOptions(planetId));
}
